'use client'

import type { MouseEventHandler } from 'react'
import { ChevronDown, Menu } from 'lucide-react'
import styles from './landing.module.css'

export function LandingMobileMenu({ contactHref }: { contactHref: string }) {
  const closeMenu: MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.currentTarget.closest('details')?.removeAttribute('open')
  }

  return (
    <details className={styles.mobileMenu}>
      <summary className={styles.menuToggle} aria-label="Menú de navegación">
        <Menu size={19} aria-hidden="true" />
        <span>Menú</span>
        <ChevronDown className={styles.menuChevron} size={14} aria-hidden="true" />
      </summary>
      <div className={styles.mobilePanel}>
        <a href="#funciones" onClick={closeMenu}>Funciones</a>
        <a href="#como-funciona" onClick={closeMenu}>Cómo funciona</a>
        <a href="#precio" onClick={closeMenu}>Precio</a>
        <a href="#preguntas" onClick={closeMenu}>Preguntas frecuentes</a>
        <a href={contactHref} onClick={closeMenu} target="_blank" rel="noopener noreferrer">
          Consultar por WhatsApp
        </a>
      </div>
    </details>
  )
}
